import * as React from 'react';

const ProjectAddGeneralComment = ({ handleShowComments, extraClass, targetId, group, comments, label, ...props }) => {
	let count = [];
	if (comments) {
		count = comments.filter((comment) => comment.target_id == targetId);
	}

	let extraClassForBtn = extraClass ? 'btn-add-comment btn-add-comment--small' : 'btn-add-comment';
	if (count.length) {
		extraClassForBtn = extraClass
			? 'btn-add-comment btn-add-comment--small btn-add-comment--added'
			: 'btn-add-comment btn-add-comment--added';
	}

	return (
		<>
			<label className='general-comment-container'>
				<div className='general-comment_wrapper'>
					<button
						className={extraClassForBtn}
						data-comments={count.length ? count.length : '+'}
						type='button'
						onClick={(ev) => handleShowComments({ targetId, group, label })}
					/>
					<span>Generell kommentar</span>
				</div>
				<button
					className='btn small light right right--light'
					type='button'
					onClick={(ev) => handleShowComments({ targetId, group, label })}
				>
					Legg til en kommentar
				</button>
			</label>
		</>
	);
};

export default ProjectAddGeneralComment;
